import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import React from 'react';

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#0096FF',
        marginTop: '0px !important ',
        borderRadius: '5px',
    },
    '&.ctotTooltip': {
        marginTop: '22px !important',
    },

    '&.ctotYellow': {
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#FFB74D',
        },
    },
    '&.ctotRed': {
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#EB3333',
        },
    },
    '&.ctotGray': {
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#607d8b',
        },
    },
});
